<template>
  <v-container grid-list-md fluid>
    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      class="white shadow align-center justify-center px-3 py-2"
    >
      <v-flex xs12 md2 style="max-width: 300px">
        <v-date
          singleLine
          v-model="date"
          @input="initData"
          :clearable="false"
          format="YYYY-MM-DD"
          :disabled="loading"
          :hideDetails="true"
          value-type="YYYY-MM-DD"
          :placeholder="$t('date')"
          input_id="compnay_date_tr"
        />
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 md2 style="max-width: 300px">
        <v-autocomplete
          outline
          singleLine
          hideDetails
          autocomplete
          :disabled="loading"
          :items="report_types"
          v-model="selected_report"
          :placeholder="$t('report')"
        />
      </v-flex>
      <v-flex xs12 md style="max-width: 300px">
        <v-autocomplete
          outline
          singleLine
          hideDetails
          autocomplete
          item-value="id"
          item-text="name"
          @change="initData"
          :disabled="loading"
          v-model="branch_id"
          :items="branch_filters"
          :placeholder="$t('branch')"
          v-if="userCan('view_all_branches_report')"
        />
      </v-flex>
      <v-btn
        icon
        medium
        flat
        @click="initData"
        :loading="loading"
        color="grey darken-2"
      >
        <v-icon>refresh</v-icon>
      </v-btn>
      <!-- <v-autocomplete
            outline
            multiple
            clearable
            single-line
            hide-details
            return-object
            item-value="id"
            item-text="name"
            :items="currencies"
            :label="$t('currency')"
            style="max-width: 300px"
            v-model="selected_currencies"
          /> -->
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <customer-accounts
          :show-filter="true"
          :customers="individuals"
          :title="$t('individuals')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'individuals'"
        />

        <customer-accounts
          :show-filter="true"
          :customers="corporates"
          :title="$t('corporates')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'corporates'"
        />

        <customer-accounts
          :show-filter="true"
          :customers="customers"
          :title="$t('customers')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'customers'"
        />

        <customer-accounts
          :show-filter="true"
          :customers="staffs"
          :title="$t('staffs')"
          :currencies="computedCurrencies"
          v-if="selected_report == 'staffs'"
          :brnch_name="selectedBranch.name"
        />

        <customer-accounts
          :show-filter="true"
          :customers="sarafs"
          :title="$t('sarafs')"
          :currencies="computedCurrencies"
          v-if="selected_report == 'sarafs'"
          :brnch_name="selectedBranch.name"
        />

        <customer-accounts
          :show-filter="true"
          :customers="commissions"
          :title="$t('sarafs_commission')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'commission'"
        />

        <customer-accounts
          :show-filter="true"
          :customers="cci"
          :title="$t('cci')"
          v-if="selected_report == 'cci'"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"

        />
        <customer-accounts
          :customers="expenses"
          :title="$t('expenses')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'expenses'"
        />

        <customer-accounts
          :customers="incomes"
          :title="$t('incomes')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'incomes'"
        />

        <customer-accounts
          :customers="assets"
          :title="$t('assets')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'assets'"
        />

        <customer-accounts
          :show-filter="true"
          :customers="shareholders"
          :title="$t('shareholders')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'shareholders'"
        />

        <customer-accounts
          :show-filter="true"
          :customers="branches"
          :title="$t('branches')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'branches'"
        />
        <!-- <customer-accounts
          :external="true"
          :currencies="currencies"
          :customers="stock"
          :title="$t('stock')"
        />-->
        <branch-account-report
          :customers="system"
          :title="$t('branch_accounts')"
          :currencies="computedCurrencies"
          :brnch_name="selectedBranch.name"
          v-if="selected_report == 'branch_accounts'"
        />
        <!-- <summery
            v-bind="{
              date,
              system,
              incomes,
              branches,
              expenses,
              corporates,
              currencies,
              individuals,
              old_balance,
              DailyProfit,
              shareholders,
              daily_changes,
              stock,
              rates: mapped_rates,
            }"
            ref="summery"
          /> -->
        <!-- <rate-table @reload="ratesUpdated" v-bind="{ rates, date }" /> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import summery from "./summery.vue";
// import RateTable from "./RateTable.vue";
import { customersMixin } from "@/mixins/index.js";
import customerAccounts from "./customerAccounts.vue";
import branchAccountReport from "./branchAccountReport.vue";
export default {
  name: "companyReport",
  components: { customerAccounts, branchAccountReport },
  mixins: [customersMixin],
  data: () => ({
    accounts: [],
    rates: [],
    loading: false,
    old_balance: 0,
    mapped_rates: {},
    daily_changes: [],
    branch_id: "",
    branch_filters: [],
    selected_currencies: [],
    selected_report: "individuals",
    date: new Date().toLocaleDateString("en-ca"),
  }),

  computed: {
    selectedBranch: (vm) =>
      vm.branch_filters.find((x) => x.id == vm.branch_id) || {},
    currencies() {
      return this.initialData.currencies;
    },
    computedCurrencies: (vm) =>
      vm.selected_currencies.length > 0
        ? vm.selected_currencies
        : vm.currencies,

    report_types() {
      return [
        { text: this.$t("individuals"), value: "individuals" },
        { text: this.$t("corporates"), value: "corporates" },
        { text: this.$t("customers"), value: "customers" },
        { text: this.$t("staffs"), value: "staffs" },
        { text: this.$t("sarafs"), value: "sarafs" },
        { text: this.$t("sarafs_commission"), value: "commission" },
        { text: this.$t("cci"), value: "cci" },
        { text: this.$t("expenses"), value: "expenses" },
        { text: this.$t("incomes"), value: "incomes" },
        { text: this.$t("assets"), value: "assets" },
        { text: this.$t("shareholders"), value: "shareholders" },
        { text: this.$t("branches"), value: "branches" },
        { text: this.$t("branch_accounts"), value: "branch_accounts" },
      ];
    },

    branches: (vm) => vm.accounts.filter((x) => x.type == "branch"),
    incomes: (vm) => vm.accounts.filter((x) => x.type == "income"),
    assets: (vm) => vm.accounts.filter((x) => x.type == "asset"),
    expenses: (vm) => vm.accounts.filter((x) => x.type == "expense"),
    customers: (vm) => vm.accounts.filter((x) => x.type == "customer"),
    staffs: (vm) => vm.accounts.filter((x) => x.type == "staff"),
    sarafs: (vm) => vm.accounts.filter((x) => x.type == "saraf"),
    commissions: (vm) => vm.accounts.filter((x) => x.type == "commission"),
    corporates: (vm) => vm.accounts.filter((x) => x.type == "corporate"),
    individuals: (vm) => vm.accounts.filter((x) => x.type == "individual"),
    DailyProfit: (vm) => vm.accounts.filter((x) => x.type == "DailyProfit"),
    shareholders: (vm) => vm.accounts.filter((x) => x.type == "shareholder"),
    stock: (vm) => vm.accounts.filter((x) => x.type == "stock"),
    system: (vm) =>
      vm.accounts.filter(
        (x) =>
          x.system_account == true &&
          x.type != "stock" &&
          x.type != "income" &&
          x.type != "DailyProfit"
      ),
    stock: (vm) => vm.accounts.filter((x) => x.type == "stock"),
    cci: (vm) =>
      vm.accounts.filter(
        (x) =>
          x.type == "individual" ||
          x.type == "corporate" ||
          x.type == "customer" ||
          x.type == "staff" ||
          x.type == "saraf" ||
          x.type == "branch" ||
          x.type == "shareholder"
      ),
  },

  methods: {
    async ratesUpdated() {
      await this.initData();
      this.$refs.summery.save();
    },

    getBranches() {
      this.axios.get("branches").then((res) => {
        this.branch_filters = res.data;
      });
    },

    async initData() {
      this.loading = true;
      await this.axios
        .get(
          `reports?company_report=true&ledger=true&end_date=${this.date}&branch_id=${this.branch_id}`
        )
        .then((res) => {
          this.rates = res.data.rates;
          this.mapped_rates = res.data.mapped_rates;
          this.daily_changes = res.data.daily_changes;
          let accounts = Object.keys(res.data.accounts).map(
            (k) => res.data.accounts[k]
          );
          this.accounts = accounts;
          this.old_balance = res.data.old_balance;
        })
        .catch((err) => {
          console.loading(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.branch_id = this.userBranch.id;
    this.initData();
    this.getBranches();
    this.getCustomers();
  },
};
</script>
